module.exports = __webpack_public_path__ + "img/ns.81a616b2.png";